import { ImageWithFallback } from "./figma/ImageWithFallback";

interface FlipCardProps {
  item: { num: number; label: string; color: string; content: string; img: string };
}

const FlipCard = ({ item }: FlipCardProps) => {
  return (
    <div className="perspective-1000 w-64 h-64 mx-auto">
      <div className="relative w-full h-full group">
        <div className="absolute w-full h-full transition-transform duration-700 [transform-style:preserve-3d] rounded-full"
          style={{ perspective: "1000px" }}
        >
          <div className={`absolute overflow-hidden flex-col w-full h-full rounded-full ${item.color} shadow-lg flex items-center justify-center text-white text-center p-4 [backface-visibility:hidden] z-20 flipcard-front`}>
            <ImageWithFallback
              src={item.img}
              alt={item.label}
              className="absolute inset-0 w-full h-full object-cover"
              style={{ position: "absolute", top: 0, left: 0 }}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-forest-green/40 via-slate-600/20 to-leaf-green/30 backdrop-brightness-90 rounded-3xl"></div>
            <h2 className="text-5xl font-bold relative z-10">{item.num}</h2>
            <h3 className="text-2xl font-bold relative z-10">{item.label}</h3>
          </div>
          <div className={`absolute w-full h-full rounded-full ${item.color} flex items-center justify-center text-white text-center p-4 [backface-visibility:hidden] [transform:rotateY(180deg)] flipcard-back z-30`}>
            <p className="text-md font-semibold text-slate-700">{item.content}</p>
          </div>
        </div>
        <style>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .group:hover .flipcard-front,
        .group:focus-visible .flipcard-front {
          transform: rotateY(180deg);
        }
        .group:hover .flipcard-back,
        .group:focus-visible .flipcard-back {
          transform: rotateY(0deg);
        }
        .flipcard-front, .flipcard-back {
          transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
        }
        .flipcard-front {
          transform: rotateY(0deg);
        }
        .flipcard-back {
          transform: rotateY(180deg);
        }
        `}</style>
      </div>
    </div>
  );
};

export default FlipCard;